import type { AddressBaseFormProps } from './AddressBaseForm';
import { AddressBaseForm } from './AddressBaseForm';
import { usePostalAddressLookupLazyQuery } from 'generated/gql';

const AddressForm = (args: AddressBaseFormProps) => {
  const [postalAddressLookup, { error, loading: isLoading }] = usePostalAddressLookupLazyQuery();

  return (
    <AddressBaseForm
      {...args}
      error={error}
      loading={isLoading}
      postalAddressLookup={(variables) => {
        return postalAddressLookup({
          variables,
        }).then(({ data }) => data?.postalAddressLookup);
      }}
    />
  );
};

export { AddressForm };
